import DIApi from './_diApi';

class BranchAPI extends DIApi {
  controllerName = 'Branchs';
}

export default new BranchAPI();
